import { MRT_Row } from '@talentmesh/table';
import { SmallBadge } from '@talentmesh/ui/components/badge';
import { MembershipStatus, TeamMember } from '@/Models/TeamMember';
import UIStrings from '@/Utils/UIStrings';

interface StatusProps {
    row: MRT_Row<TeamMember>;
}

function getLabel(status: MembershipStatus): string {
    switch (status) {
        case 'Invited':
            return UIStrings.Invited;
        case 'Member':
            return UIStrings.Member;
        case 'Expired':
            return UIStrings.Expired;
        default:
            throw new Error(`Unknown status: ${status}`);
    }
}

function Status({ row }: StatusProps) {
    const { status } = row.original;
    return <SmallBadge variant={status === 'Member' ? 'default' : 'secondary'}>{getLabel(status)}</SmallBadge>;
}

export default Status;
